import ApiBaseService from "services/ApiBaseService.js";

class TranslationService {
  static translate({ text, sourceLang, targetLang }) {
    return ApiBaseService.request("/translate", "POST", {
      text,
      sourceLang,
      targetLang,
    });
  }
}

export default TranslationService;
